const CONNECTION_STATUS = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  SLOW: 'slow'
}

export default CONNECTION_STATUS
